module.exports = __webpack_public_path__ + "img/img4.d3b57b00.png";